module.exports = __webpack_public_path__ + "cb7557ecec57b5b2807d1491fe87783f.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/path4.svg
// module id = 653
// module chunks = 0